import React from "react";
import CustomReportContainer from "../../containers/CustomReport";

const CustomReportPage = () => {
  return <CustomReportContainer />;
};

export default CustomReportPage;
